import { Component } from '@angular/core';

@Component({
    selector: 'app-self-assist',
    imports: [],
    templateUrl: './self-assist.component.html',
    styleUrl: './self-assist.component.scss'
})
export class SelfAssistComponent {

}
